import React, { Component } from 'react';
import {FormError} from './FormError';
import {FormErrors} from './FormErrors';
import {loadCsrf} from './common/CsrfFetcher';
import {Modal} from 'react-bootstrap';
import {FormControl,FormGroup,ControlLabel,HelpBlock} from 'react-bootstrap';
import Loader from 'react-loader';

function validateResponse(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

function logResult(result) {
  console.log('the result is  .... \n\n\n', result);
}

class EventAttendanceTracking extends Component {

  constructor (props) {

      super(props);
      this.state = {
          csrfToken:'',
          csrfTokenHeaderName:'',
          eventUpload: {value:'', isValid: '', message:'', file:''},
          events: [],
          showAppendModal: false,
          scoreTrackingMetadata:{},
          showDeleteModal: false,
          eventToDelete: {id:'', name:''},
          genericFormLevelProblems:'',
          submissionSuccesMessage:'',
          isFileUploadFinished:true
      }

      this.loadEventsFromServer = this.loadEventsFromServer.bind(this);
      this.handleDeleteEventData = this.handleDeleteEventData.bind(this);
      this.handleUserInput = this.handleUserInput.bind(this);
      this.getValidationState = this.getValidationState.bind(this);
      this.validateField = this.validateField.bind(this);
      this.handleAppendOrCreateNew = this.handleAppendOrCreateNew.bind(this);

    }

    componentDidMount() {
      loadCsrf(this.setCsrfState);
      this.loadEventsFromServer();
    }

    setCsrfState = (csrfToken, csrfHeaderValue)=>{
      var state = this.state;
      state.csrfToken = csrfToken;
      this.csrfHeaderValue = csrfHeaderValue;
      this.setState({
        state
      });
    }

    loadEventsFromServer() {
      var self = this;

      fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/adminConsole/scoreTracking/events', {
        headers: {
          'Accept': 'application/json',
          },
          credentials: 'include'
          })
          .then(results=> {
              validateResponse(results);
              return results.json();
          })
          .catch(error => {
              console.log('You better believe there was an error:\n', error);
              return Promise.reject()
          })
          .then(data => {
              self.setState({events: data});
          });
    }

    handleUpload = (event) =>{
      console.log("event is " + event.target.name);
      this.validateField("eventUpload", this.state.eventUpload.value);
      if(!this.state.eventUpload.isValid){
        console.log("not Valid, returning without submitting ");
        return;
      }

      const data = new FormData();
      data.append('file', this.state.eventUpload.file);
      data.append('eventName', this.state.eventUpload.value);
      this.setState({isFileUploadFinished:false});

      fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/adminConsole/scoreTracking/upload', {
          headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': this.state.csrfToken,
            body: data
          },
          credentials: 'include',
          method: 'POST',
          body: data
        })
          .then(results=> {
              if (!results.ok) {
                console.log("response is not ok " + results.statusText  + " with status of " + results.status);
                if(results.status === 400 ){
                  return results.json();
                }
                throw new Error("Unknown Problem occurred : " + results.statusText);
              }
              return results.json();

          })
          .catch(error => {
              this.setState({
                                genericFormLevelProblems:['There was an error uploading the file :\n' + error],
                                isFileUploadFinished:true,
                                submissionSuccesMessage:''
                            })
              return Promise.reject();
          })
          .then(data => {
                if(data.errorCode){
                    console.log("there was an error... " + data.errorCode);
                    this.setState({
                                      genericFormLevelProblems:['There was an error uploading the file :\n' + data.message],
                                      isFileUploadFinished:true,
                                      submissionSuccesMessage:''
                                  })

                }
                else{
                    this.setState({
                                    scoreTrackingMetadata: data,
                                    submissionSuccesMessage: 'Your Event Data was uploaded.  Please see below for results and any email addresses which did not match.',
                                    genericFormLevelProblems:'',
                                    isFileUploadFinished:true
                                });
                    this.loadEventsFromServer();
                }
          });
  }

  handleDeleteEventData = (event) =>{
    let eventId = this.state.eventToDelete.id;

    fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/adminConsole/scoreTracking/events/'+eventId, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-TOKEN': this.state.csrfToken
        },
        credentials: 'include',
        method: 'DELETE'
      })
        .then(results=> {
            validateResponse(results);
            logResult(results);

            return results.json();
        })
        .catch(error => {
            console.log('There was an error deleting:\n', error);
            this.setState({genericFormLevelProblems:["There was an error deleting your event " + eventId + " with error message " + error.message]})
            return Promise.reject();
        })
        .then(data => {
            this.setState({events: data});
            this.handleReset();
        });
  }


  getValidationState(){
    let isValid = this.state.eventUpload.isValid;
    if(isValid === ''){
      return null;
    }
    if(isValid){
      return 'success';
    }
    else{
      return 'error';
    }
  }

  handleUserInput(e) {
      const name = e.target.name;
      const value = e.target.value;

        //alphanumeric, spaces, underscores
        e.target.value=e.target.value.toUpperCase().replace(/[^\w\s]/gi, '')

        var state = this.state;
        state[name].value = e.target.value;
        state.genericFormLevelProblems='';
        this.setState(state,
                      () => { this.validateField(name, value) });
  }

  handleReset = () => {

    this.setState({
      eventUpload: {value:'', isValid: '', message:'', file:''},
      scoreTrackingMetadata:{},
      eventToDelete: {id:'', name:''},
      genericFormLevelProblems:'',
      submissionSuccesMessage:''
    });
    this.getValidationState();
}

  validateField(fieldName, value) {
    console.log("validateField fieldName: " + fieldName + " fieldValue " + value );

    var state = this.state;
    const length = state[fieldName].value.length;
     if (length >= 5){
      state[fieldName].isValid = true;
      state[fieldName].message = "";
    }
    else {
      state[fieldName].isValid = false;
      state[fieldName].message = "Error: Event Name should be at least five characters";
    }

    this.setState(state);
  }

  confirmDeleteModal = (e)=>{
    let eventId = e.target.name;
    let eventName = e.target.value;
    this.setState({ eventToDelete:{id: eventId, name: eventName},
                    showDeleteModal:true
                  });
  }

  handleHideDeleteModal =(e) =>	{
    console.log("name is " + e.name);
    this.setState({
		  ...this.state,
		  showDeleteModal: false
	  })

  }

  handleCloseDeleteModal = (e) => {
    const name = e.target.name;
    if(name === 'YES'){
      this.handleDeleteEventData(e);
    }
    this.setState({
      ...this.state,
      showDeleteModal: false,
    })

  }

  handleAppendOrCreateNew(e){
    var state = this.state;
    var eventUploadName =  state.eventUpload.value;
    state.eventUpload.file = e.target.files[0];
    var existingEventFound = false;
    state.scoreTrackingMetadata = '';
    state.events.forEach(function(eventItem) {
      if(eventItem.name === eventUploadName){
        existingEventFound = true;
      }
    });
    console.log('existingEventFound' + existingEventFound);
    if(existingEventFound){
      state.showAppendModal=true;
      this.setState(state);
    }
    else{
      this.handleUpload(e);
    }
  }


  handleHideAppendModal =(e) =>	{
    this.setState({
      showAppendModal: false
    })

  }

  handleCloseAppendModal = (e) => {
    const name = e.target.name;

    if(name === 'Continue'){
      this.handleUpload(e);
    }
    this.setState({
      showAppendModal: false
    })

  }

  handleCsvInputFileClick = (e) => {
      //reset the file value so if they chose the same file, it still fires 'onChange' event
      e.target.value = '';
  }


  hideClass = () => {
      if(this.state.submissionSuccesMessage===''){
          return 'hide';
      }
      else{
          return 'show';
      }
  }

  render() {

    return[
        <div className="container">
          <form>
            <FormErrors formErrors={this.state.genericFormLevelProblems} />

            <div className={`alert alert-success text-white ${this.hideClass()}`} role="alert">
                <span className="fas fa-exclamation-circle" aria-hidden="true"></span>
                {this.state.submissionSuccesMessage}
            </div>

            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}>
              <ControlLabel>Enter the Event Name</ControlLabel>
              <FormError errorMessage={this.state.eventUpload.message } />
              <FormControl
                name="eventUpload"
                type="text"
                value={this.state.eventUpload.value}
                placeholder="Enter Event Name"
                onChange={this.handleUserInput}
                maxLength="30"
              />

            <FormControl.Feedback text={this.state.eventUpload.message}></FormControl.Feedback>
              <HelpBlock>Alphanumberic, underscores and spaces allowed.  If you use the same Event Name, your data will be appended to the existing event's data.</HelpBlock>
            </FormGroup>
            <FormGroup>
              <label htmlFor="file">Choose a CSV file to upload.
                  Contents should just contain only email addresses, 1 per row. Max 1000 emails per upload.
              </label>
              <input
                  id="csvInput"
                  name="csvInputFile"
                  type="file"
                  onChange={this.handleAppendOrCreateNew}
                  onClick={this.handleCsvInputFileClick}
                  accept= "text/csv" />
            </FormGroup>

          </form>

          <Modal onHide={this.handleHideDeleteModal} show={this.state.showDeleteModal} aria-labelledby="ModalHeader" animation={false}>
            <Modal.Header closeButton className="modal-eventatendancetracking">
              <Modal.Title id='ModalHeader'>WARNING: About to delete attendance record</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete the records for {this.state.eventToDelete.name} ? </p>
            </Modal.Body>
            <Modal.Footer>
              <button className='btn btn-primary' onClick={this.handleCloseDeleteModal} name="YES">
                Yes
              </button>
              <button className='btn btn-primary' onClick={this.handleCloseDeleteModal} name="NO">
                No
              </button>
            </Modal.Footer>
          </Modal>

          <Modal onHide={this.handleHideAppendModal} show={this.state.showAppendModal} aria-labelledby="ModalHeader" animation={false}>
            <Modal.Header closeButton className="modal-eventatendancetracking">
              <Modal.Title id='ModalHeader'>New file upload </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>The event name you chose already exists.  Click continue to append the new data to the existing data for the Event named:  {this.state.eventUpload.value} </p>
            </Modal.Body>
            <Modal.Footer>
              <button className='btn btn-primary' onClick={this.handleCloseAppendModal} name="Continue">
                Continue
              </button>
              <button className='btn btn-primary' onClick={this.handleCloseAppendModal} name="Cancel">
                Cancel
              </button>
            </Modal.Footer>
          </Modal>

        <Loader loaded={this.state.isFileUploadFinished}>
            <ResultsTable scoreTrackingMetadata={this.state.scoreTrackingMetadata} />
        </Loader>

        <EventTable events={this.state.events} csrfToken={this.state.csrfToken} deleteMethod={this.confirmDeleteModal}/>
        </div>
        ];
    }
  }

    class ResultsTable extends React.Component{

      render() {
        let metadata = this.props.scoreTrackingMetadata;
        //if we have in id... we uploaded.
        if(metadata.id){
          var failedEmailRecords = [];
          metadata.failedRecords.forEach(function(failedEmail) {
            failedEmailRecords.push(<div id="failedEmail" key={failedEmail}>{failedEmail}</div>);
          });
          return(
              <div className="container">
                <p>Upload completed with the following results.</p>
                <p>Number of successful records: {metadata.totalSuccess}</p>
                <p>Number of failed records: {metadata.failedRecords.length}</p>

                  <div>
                    {failedEmailRecords}
                  </div>
              </div>
          )
        }
        else{
          return(
              <p></p>
            )
        }
      }
    }


    class EventTable extends React.Component {

      render() {
        var rows = [];
        let deleteMethod = this.props.deleteMethod;
        this.props.events.forEach(function(eventItem) {
          rows.push(<Event eventItem={eventItem} deleteMethod={deleteMethod} key={eventItem.name}/>);
        });
        return (
        <div className="container">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Event Name</th>
                <th>Date Created</th>
                <th>Total Users</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </div>

        );
      }
    };


    class Event extends React.Component {
      render() {
          var dateCreatedFormatted = new Date(this.props.eventItem.dateCreated).toISOString().substring(0, 10);

          return (
            <tr>
              <td id={this.props.eventItem.name}>{this.props.eventItem.name}</td>
              <td>{ dateCreatedFormatted }</td>
              <td>{this.props.eventItem.totalSuccess}</td>
              <td>
                <button className="btn btn-primary" onClick={this.props.deleteMethod} name={this.props.eventItem.id} value={this.props.eventItem.name} >
                  Delete
                </button>
              </td>
            </tr>
          );
        }
    };
export default EventAttendanceTracking;



// WEBPACK FOOTER //
// ./src/EventAttendanceTracking.js